import React, { useCallback, useRef, VFC } from 'react';
import { LibraryContentCardTypeEnum } from 'src/common/components/library/content-card/type.enum';
import { Node } from 'src/common/interfaces/node.interface';
import { Step } from 'src/common/interfaces/step.interface';
import { EditorSectionStepCard } from 'src/editor/section/step-card';
import { useEditorNavigator } from 'src/editor/use-editor-navigator.hook';

type NodeWithStep = {
  node: Node;
  step: Step;
};
interface DashboardHomeJourneysExpandedProps {
  nodes: NodeWithStep[];
}

export const DashboardHomeJourneysExpanded: VFC<DashboardHomeJourneysExpandedProps> = ({ nodes }) => {
  const expandedElementHeightRef = useRef(0);
  const expandedElementRef = useCallback((element: HTMLDivElement) => {
    if (element) {
      expandedElementHeightRef.current = element.clientHeight;
    }
  }, []);
  const { navigateToStepEdit } = useEditorNavigator();

  const containerElementRef = useCallback((element: HTMLDivElement) => {
    if (element) {
      element.setAttribute('style', `height: ${expandedElementHeightRef.current}px`);
    }
  }, []);

  const onCardClicked = useCallback(
    (nodeId: Node['id']) => () => {
      navigateToStepEdit(nodeId);
    },
    [navigateToStepEdit]
  );

  return (
    <div
      ref={containerElementRef}
      className='relative after:absolute after:inset-y-0 after:right-0 after:h-full after:w-4 after:bg-gradient-to-l after:from-bedrock-white after:to-transparent'
    >
      <div
        ref={expandedElementRef}
        className='absolute flex grow-0 flex-nowrap items-start space-x-md overflow-x-auto max-w-full'
      >
        {nodes.map(({ node, step }) => (
          <EditorSectionStepCard
            key={`editor-content-card-${node.uuid}`}
            node={node}
            step={step}
            type={LibraryContentCardTypeEnum.DASHBOARD}
            onClick={onCardClicked(node.id)}
            draggable={false}
            isDragging={false}
          />
        ))}
      </div>
    </div>
  );
};
